import { Component, Inject, OnInit } from '@angular/core';
import {
  MSAL_GUARD_CONFIG,
  MsalBroadcastService,
  MsalGuardConfiguration,
  MsalService,
} from '@azure/msal-angular';
import { EventMessage, EventType, RedirectRequest } from '@azure/msal-browser';
import { environment } from '@environments';
import { filter } from 'rxjs';

import { SSOProvider } from '../../auth.model';

@Component({
  selector: 'via-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  isLoginButtonVisible = false;

  get SSOProvider() {
    return SSOProvider;
  }

  constructor(
    private msalService: MsalService,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private msalBroadcastService: MsalBroadcastService
  ) {
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType !== EventType.LOGIN_SUCCESS)
      )
      .subscribe((result: EventMessage) => {
        if (
          result.eventType === EventType.LOGIN_FAILURE ||
          result.eventType === EventType.ACQUIRE_TOKEN_FAILURE ||
          result.eventType === EventType.SSO_SILENT_FAILURE ||
          result.eventType === EventType.LOGOUT_FAILURE
        ) {
          // visible login button if login failed
          this.isLoginButtonVisible = true;
        }
        // hide login button if login is in progress
        this.isLoginButtonVisible = false;
      });
  }

  ngOnInit(): void {
    // msal broadcast service sending events with delay
    setTimeout(() => {
      this.isLoginButtonVisible =
        this.msalService.instance.getAllAccounts().length === 0;
    }, 1500);
  }

  loginWithSSO(provider: SSOProvider) {
    switch (provider) {
      case SSOProvider.Google:
        break;
      case SSOProvider.Microsoft:
        this.msalService.loginRedirect({
          ...this.msalGuardConfig.authRequest,
        } as RedirectRequest);
        break;
      case SSOProvider.Email:
        this.msalService.loginRedirect({
          ...this.msalGuardConfig.authRequest,
          authority: `https://login.microsoftonline.com/${environment.AZURE_SSO_TENANT_ID}`,
        } as RedirectRequest);

        break;
    }
  }
}
